export default "__VITE_ASSET__grrtkZCU__"